exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui.dropdown .menu>.item.current{background:rgba(0,0,0,.05)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-88a61080!./~/vue-loader/lib/selector.js?type=styles&index=2!./src/components/lib/AjaxMultiSelect.vue
// module id = 155
// module chunks = 0